import { render, staticRenderFns } from "./PublisherUsers.vue?vue&type=template&id=21f32942&scoped=true&lang=pug"
import script from "./PublisherUsers.vue?vue&type=script&lang=js"
export * from "./PublisherUsers.vue?vue&type=script&lang=js"
import style0 from "./PublisherUsers.vue?vue&type=style&index=0&id=21f32942&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f32942",
  null
  
)

export default component.exports